import { Form } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';

const SubSectionSeparator = (props) => {
  return <div className='sub-section-separator position-relative mb-3'>
    <Form.Label><FormattedMessage id={props.title} /></Form.Label>
  </div>
}
export default SubSectionSeparator;